import React from 'react'
import styled from 'styled-components'

import { header3 } from 'styles/texts'
// import AvailabilityDropdown from './AvailabilityDropdown'
import Consultant from './Consultant'

const Wrapper = styled.div`
  padding: 20px 10px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 10px 10px;
  margin: 0 auto;
  max-width: 355px;

  @media (min-width: 635px) {
    & {
      height: 53px;
      margin-top: 10px;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      max-width: 710px;
    }
  }

  @media (min-width: 935px) {
    & {
      max-width: 930px;
    }
  }
`

const Heading = styled.div`
  ${header3};
  margin-bottom: 20px;

  & img {
    width: 20px;
    position: relative;
    top: 3px;
    margin-left: 5px;
  }

  @media (min-width: 635px) {
    & {
      margin-bottom: 0;
    }
  }
`

const Count = styled.span`
  font-weight: 700;
`

const List = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 930px;
  margin: 0 auto;
`

const ConsultantList = ({
  consultantIds = [],
  title = count => (count === 1 ? 'konsulent' : 'konsulenter'),
  availabilityDropdown,
  ...rest
}) => {
  return (
    <Wrapper>
      <Header>
        <Heading>
          <Count>{consultantIds.length}</Count> <img src="/user.svg" alt="ungdommer" />
        </Heading>
        {/* availabilityDropdown && <AvailabilityDropdown /> */}
      </Header>
      <List>
        {consultantIds.map(consultantId => (
          <Consultant
            key={consultantId}
            consultantId={consultantId}
            {...rest}
          />
        ))}
      </List>
    </Wrapper>
  )
}

export default ConsultantList



// WEBPACK FOOTER //
// ./src/components/ConsultantList/index.js